<template>
  <div>
    <!-- Hero Section -->
    <section class="relative overflow-hidden py-20 sm:py-32">
      <div class="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-gray-50"></div>
      <div class="container mx-auto px-4 relative z-10">
        <div class="max-w-4xl mx-auto text-center">
          <div class="inline-flex items-center rounded-full border border-gray-200 bg-white/70 px-4 py-2 text-sm backdrop-blur-xl shadow-sm">
            <span class="flex h-2 w-2 rounded-full bg-blue-500 mr-2 animate-pulse"></span>
            {{ t('quoteWebsite.hero.tagline') }}
          </div>
          <h1 class="mt-8 text-4xl md:text-6xl font-bold tracking-tight">
            {{ t('quoteWebsite.hero.title') }}
          </h1>
          <p class="mt-6 text-xl text-gray-600 max-w-3xl mx-auto">
            {{ t('quoteWebsite.hero.description') }}
          </p>
        </div>
      </div>
    </section>

    <QuoteGenerator />
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import QuoteGenerator from '../components/QuoteGenerator.vue'

const { t } = useI18n()

defineOptions({
  name: 'QuoteWebsitePage'
})
</script>


